<template>
  <section>
    <div class="container">
      <div class="profile-author mb-4 mb-lg-5"></div>
      <div class="row">
        <div class="woocommerce">
          <div class="woocommerce-notices-wrapper"></div>
          <form
            name="checkout"
            method="post"
            class="checkout woocommerce-checkout"
            action="."
            enctype="multipart/form-data"
            novalidate="novalidate"
          >
            <div class="row">
              <div class="col-lg-5 ml-auto mb-lg-0 mb-3 order-2 mt-lg-4">
                <div class="ml-0 ml-lg-4 card card--summary">
                  <div class="card-body">
                    <h3 id="order_review_heading">Your order</h3>
                    <div
                      id="order_review"
                      class="woocommerce-checkout-review-order"
                    >
                      <table
                        class="shop_table woocommerce-checkout-review-order-table"
                      >
                        <thead>
                          <tr>
                            <th class="product-name">Product</th>
                            <th class="product-total">Subtotal</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="cart_item">
                            <td class="product-name">
                              Product – Name &amp; Short Description
                              <dl class="variation">
                                <dt class="variation-Vendor">Vendor:</dt>
                                <dd class="variation-Vendor">
                                  <p>Bootlab</p>
                                </dd>
                                <dt class="variation-LicenseType">
                                  Additional Info:
                                </dt>
                                <dd class="variation-LicenseType">
                                  <p>Property Value</p>
                                </dd>
                              </dl>
                            </td>
                            <td class="product-total">
                              <span class="woocommerce-Price-amount amount"
                                >{{ productPrice.toFixed(2) }}<span class="woocommerce-Price-currencySymbol ml-1"
                                  >{{ currency.symbol }}</span
                                ></span
                              >
                              <br />
                              <strong class="product-quantity">×&nbsp;</strong><input type="number" min="1" max="10" class="mt-1 pl-2" v-model="productCount" @change="onProductCountChange"/>
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr class="cart-subtotal">
                            <th>Subtotal</th>
                            <td>
                              <span class="woocommerce-Price-amount amount"
                                >{{ orderTotal }}<span class="woocommerce-Price-currencySymbol ml-1"
                                  >{{ currency.symbol }}</span
                                ></span
                              >
                            </td>
                          </tr>
                          <tr class="order-total">
                            <th>Total</th>
                            <td>
                              <strong
                                ><span class="woocommerce-Price-amount amount"
                                  >{{ orderTotal }}<span
                                    class="woocommerce-Price-currencySymbol ml-1"
                                    >{{ currency.symbol }}</span
                                  ></span
                                ></strong
                              >
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                      <div id="payment" class="woocommerce-checkout-payment">
                        <ul class="wc_payment_methods payment_methods methods">
                          <li class="wc_payment_method payment_method_stripe">
                            <input
                              id="payment_method_stripe"
                              type="radio"
                              class="input-radio"
                              name="payment_method"
                              value="stripe"
                              checked="checked"
                              data-order_button_text=""
                              :disabled="loading"
                            />
                            <label for="payment_method_stripe"
                              >Bank Payment</label
                            >
                            <div
                              class="payment_box payment_method_stripe"
                              style="display: block"
                            >
                              <div
                                id="stripe-payment-data"
                                data-email=""
                                data-full-name=" "
                                data-currency="usd"
                              >
                                <p>
                                  Pay directly from your bank account using Open
                                  Banking.
                                </p>
                                <fieldset
                                  id="wc-stripe-cc-form"
                                  class="wc-credit-card-form wc-payment-form"
                                  style="background: transparent"
                                >
                                  <div class="form-row form-row-wide">
                                    <label for="stripe-card-element"
                                      >Bank Name
                                      <span class="required">*</span></label
                                    >
                                    <div class="stripe-card-group">
                                      <select
                                        name="aspsp_name"
                                        id="aspsp_name"
                                        class="form-control"
                                        autocomplete="country"
                                        tabindex="-1"
                                        aria-hidden="true"
                                        :disabled="loading || !country || !aspsps.length"
                                        v-model="aspspName"
                                      >
                                        <option value="">
                                          Select your bank
                                        </option>
                                        <option
                                          v-for="aspsp of aspsps"
                                          :key="aspsp.name"
                                          :value="aspsp.name"
                                        >
                                          {{ aspsp.name }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="clear"></div>
                                  <!-- Used to display form errors -->
                                  <div
                                    class="stripe-source-errors"
                                    role="alert"
                                  ></div>
                                  <br />
                                  <div class="clear"></div>
                                </fieldset>
                              </div>
                            </div>
                          </li>
                          <li class="wc_payment_method payment_method_paypal">
                            <input
                              id="payment_method_paypal"
                              type="radio"
                              class="input-radio"
                              name="payment_method"
                              value="paypal"
                              data-order_button_text="Proceed to PayPal"
                              :disabled="loading"
                            />
                            <label for="payment_method_paypal"
                              >Credit Card</label
                            >
                          </li>
                        </ul>
                        <div class="form-row place-order">
                          <div class="woocommerce-terms-and-conditions-wrapper">
                            <div class="woocommerce-privacy-policy-text"></div>
                          </div>
                          <button
                            type="submit"
                            class="btn btn-lg btn-block btn-theme alt"
                            style="cursor: pointer"
                            name="woocommerce_checkout_place_order"
                            id="place_order"
                            data-value="Pay now"
                            @click.prevent="onPay($event)"
                            :disabled="loading || !country || !aspspName"
                          >Pay now <LoaderPic class="btn-loader" v-if="initiatedPayment" /></button>
                        </div>
                      </div>
                    </div>
                    <small class="text-center mt-3 mb-1 d-block"
                      ><strong>100% Satisfaction Guarantee</strong><br /><span
                        class="text-gray-soft"
                        >Don't love your buy? We'll issue you a full
                        refund.</span
                      ></small
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-7 order-1 mt-lg-4">
                <!-- Tab panes-->
                <div class="tab-content">
                  <div class="col2-set" id="customer_details">
                    <div class="col-billing">
                      <div class="woocommerce-billing-fields">
                        <h3>Billing details</h3>
                        <div class="woocommerce-billing-fields__field-wrapper">
                          <p
                            class="form-row form-row-first validate-required"
                            id="billing_first_name_field"
                            data-priority="10"
                          >
                            <label for="billing_first_name" class=""
                              >First name&nbsp;<abbr
                                class="required"
                                title="required"
                                >*</abbr
                              ></label
                            >
                            <span class="woocommerce-input-wrapper">
                              <input
                                type="text"
                                class="input-text"
                                name="billing_first_name"
                                id="billing_first_name"
                                placeholder=""
                                value=""
                                autocomplete="given-name"
                                :disabled="loading"
                              />
                            </span>
                          </p>
                          <p
                            class="form-row form-row-last validate-required"
                            id="billing_last_name_field"
                            data-priority="20"
                          >
                            <label for="billing_last_name" class=""
                              >Last name&nbsp;<abbr
                                class="required"
                                title="required"
                                >*</abbr
                              ></label
                            >
                            <span class="woocommerce-input-wrapper"
                              ><input
                                type="text"
                                class="input-text"
                                name="billing_last_name"
                                id="billing_last_name"
                                placeholder=""
                                value=""
                                autocomplete="family-name"
                                :disabled="loading"
                            /></span>
                          </p>
                          <p
                            class="form-row form-row-wide"
                            id="billing_company_field"
                            data-priority="30"
                          >
                            <label for="billing_company" class=""
                              >Company name&nbsp;<span class="optional"
                                >(optional)</span
                              ></label
                            >
                            <span class="woocommerce-input-wrapper"
                              ><input
                                type="text"
                                class="input-text"
                                name="billing_company"
                                id="billing_company"
                                placeholder=""
                                value=""
                                autocomplete="organization"
                                :disabled="loading"
                            /></span>
                          </p>
                          <p
                            class="form-row form-row-wide address-field update_totals_on_change validate-required"
                            id="billing_country_field"
                            data-priority="40"
                          >
                            <label for="billing_country" class=""
                              >Country&nbsp;<abbr
                                class="required"
                                title="required"
                                >*</abbr
                              ></label
                            >
                            <span class="woocommerce-input-wrapper">
                              <select
                                name="billing_country"
                                id="billing_country"
                                class="country_to_state country_select select2-hidden-accessible form-control"
                                autocomplete="country"
                                tabindex="-1"
                                aria-hidden="true"
                                v-model="country"
                                @change="onCountryChange($event)"
                                :disabled="loading"
                              >
                                <option value="">Select a country…</option>
                                <option value="DK">Denmark</option>
                                <option value="EE">Estonia</option>
                                <option value="FI">Finland</option>
                                <option value="SE">Sweden</option>
                                <option value="NO">Norway</option>
                              </select>
                            </span>
                          </p>
                          <p
                            class="form-row form-row-wide validate-required validate-email"
                            id="billing_email_field"
                            data-priority="110"
                          >
                            <label for="billing_email" class=""
                              >Email address&nbsp;<abbr
                                class="required"
                                title="required"
                                >*</abbr
                              ></label
                            >
                            <span class="woocommerce-input-wrapper"
                              ><input
                                type="email"
                                class="input-text"
                                name="billing_email"
                                id="billing_email"
                                placeholder=""
                                value=""
                                autocomplete="email username"
                                :disabled="loading"
                            /></span>
                          </p>
                        </div>
                        <p class="form-row form-row-wide mailchimp-newsletter">
                          <input
                            class="woocommerce-form__input woocommerce-form__input-checkbox input-checkbox"
                            id="mailchimp_woocommerce_newsletter"
                            type="checkbox"
                            name="mailchimp_woocommerce_newsletter"
                            value="1"
                            checked="checked"
                            :disabled="loading"
                          />
                          <label
                            for="mailchimp_woocommerce_newsletter"
                            class="woocommerce-form__label woocommerce-form__label-for-checkbox inline"
                          >
                            <span
                              >Subscribe for Sales &amp; Product Updates</span
                            >
                          </label>
                        </p>
                        <div class="clear"></div>
                      </div>
                      <div class="woocommerce-account-fields">
                        <p
                          class="form-row form-row-wide create-account woocommerce-validated"
                        >
                          <label
                            class="woocommerce-form__label woocommerce-form__label-for-checkbox checkbox"
                          >
                            <input
                              class="woocommerce-form__input woocommerce-form__input-checkbox input-checkbox"
                              id="createaccount"
                              type="checkbox"
                              name="createaccount"
                              value="1"
                              :disabled="loading"
                            />
                            <span>Create an account?</span>
                          </label>
                        </p>
                        <div class="create-account" style="display: none">
                          <p
                            class="form-row validate-required"
                            id="account_password_field"
                            data-priority=""
                          >
                            <label for="account_password" class=""
                              >Create account password&nbsp;<abbr
                                class="required"
                                title="required"
                                >*</abbr
                              ></label
                            >
                            <span class="woocommerce-input-wrapper">
                              <input
                                type="password"
                                class="input-text"
                                name="account_password"
                                id="account_password"
                                placeholder="Password"
                                value=""
                                :disabled="loading"
                              />
                            </span>
                          </p>
                          <div class="clear"></div>
                        </div>
                      </div>
                    </div>
                    <div class="col-shipping">
                      <div class="woocommerce-shipping-fields"></div>
                      <div class="woocommerce-additional-fields">
                        <h3>Additional information</h3>
                        <div
                          class="woocommerce-additional-fields__field-wrapper"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import constants from '../constants.js'
import BaseService from '../services/BaseService.js'
import LoaderPic from '../components/elements/LoaderPic.vue'

export default {
  name: 'home',
  components: {
    LoaderPic
  },
  data () {
    return {
      loading: false,
      initiatedPayment: false,
      productCount: 1,
      productPrice: 9.90,
      country: '',
      aspspName: '',
      aspsps: []
    }
  },
  computed: {
    orderTotal () {
      if (this.productCount < 1) {
        return (0).toFixed(2)
      }
      if (this.productCount > 10) {
        return (0).toFixed(2)
      }
      return (this.productCount * this.productPrice).toFixed(2)
    },
    currency () {
      const currencyCode = constants.countriesCurrencies[this.country] || "EUR"
      return {
        code: currencyCode,
        symbol: constants.currencySymbols[currencyCode] || currencyCode
      }
    }
  },
  methods: {
    async onCountryChange () {
      try {
        this.loading = true
        const r = await BaseService.getAspsps(this.country)
        this.aspsps = r.data.aspsps
      } finally {
        this.loading = false
      }
    },
    async onPay () {
      try {
        this.loading = true
        const orderNumber = this.randomAZ(6)
        const orderDate = new Intl.DateTimeFormat('en', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        }).format(new Date())
        const paymentMessage = `Order ${orderNumber} (${orderDate})`
        const r = await BaseService.initiatePayment(
          this.country,
          this.aspspName,
          { amount: this.orderTotal, currency: this.currency.code },
          paymentMessage,
          window.location.origin + '/complete')
        if (r.data.url) {
          window.localStorage.setItem('orderNumber', orderNumber)
          window.localStorage.setItem('orderDate', orderDate)
          window.localStorage.setItem('orderTotal', this.orderTotal)
          window.localStorage.setItem('productCount', this.productCount)
          window.localStorage.setItem('productPrice', this.productPrice.toFixed(2))
          this.initiatedPayment = true
          window.location.href = r.data.url
        }
      } finally {
        if (!this.initiatedPayment) {
          this.loading = false
        }
      }
    },
    onProductCountChange () {
      if (this.productCount < 1) {
        this.productCount = 1
      } else if (this.productCount > 10) {
        this.productCount = 10
      }
    },
    randomAZ (n) {
      return Array(n)
        .fill(null)
        .map(() => Math.random() * 100 % 25 + 'A'.charCodeAt(0))
        .map(a => String.fromCharCode(a))
        .join('')
    }
  },
  mounted () {
    if (this.country) {
      this.onCountryChange().then(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/style1.css";
@import "../assets/woocommerce.css";
.btn-loader {
    position: absolute;
    margin-top: -1em;
}
</style>
